/**
 * Outlook-organizer warning — renders on an interviewer chip whose
 * user_id matches the picked shared-calendar's owner (Outlook only).
 * Mirrors legacy `SchInterviewerMultiValueLabel`'s isCalendarOwner
 * branch: in Outlook, the calendar owner shows up as the event
 * organizer and doesn't receive a separate meeting invite — Kula
 * sends them a notification instead.
 */
import { Flex, Icon, Text, Tooltip } from '@chakra-ui/react';
// Dual-tone matches legacy `SchInterviewerMultiValueLabel`'s rendering
// of the same warning, so the affordance reads identically across the
// old and new wizards.
import { AlertTriangle } from '@kula-ai/icons-core';

interface InterviewerOutlookOwnerProps {
  size?: number;
}

export function InterviewerOutlookOwner({
  size = 16,
}: InterviewerOutlookOwnerProps) {
  return (
    <Tooltip
      placement="bottom"
      bg="secondary-950"
      borderRadius="6px"
      label={
        <Flex align="center" p="8px">
          <Text fontSize="xs" color="white">
            As the Outlook calendar owner, this interviewer will not receive a
            meeting invite to join the interview. They&apos;ll receive a
            notification from Kula instead.
          </Text>
        </Flex>
      }
      shouldWrapChildren
      hasArrow
    >
      <Icon
        as={AlertTriangle as unknown as React.ElementType}
        w={`${size}px`}
        h={`${size}px`}
        color="warning-200"
        flexShrink={0}
        onClick={(e) => e.stopPropagation()}
      />
    </Tooltip>
  );
}
